import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from 'src/app/services/user.service';
import { TankService } from 'src/app/services/tank.service';
import { User } from 'src/app/shared/models/User';


@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.css']
})
export class LoginPageComponent implements OnInit {
  adminLoginForm!: FormGroup;
  operatorLoginForm!: FormGroup;
  isSubmitted = false;
  returnUrl = '';
  currrentUser: User;
  adminLogin = false;


  constructor(
    private formBuilder: FormBuilder,
    private userService: UserService,
    private tankService: TankService,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit(): void {

    this.userService.welcomelogout();

    this.adminLoginForm = this.formBuilder.group({
      name: ['', Validators.required],
      password: ['', Validators.required]
    });

    this.operatorLoginForm = this.formBuilder.group({
      operatorCode: ['', Validators.required],
    });


    this.adminLogin = false;
    //this.returnUrl = this.activatedRoute.snapshot.queryParams.returnUrl;
  }

  get afc() {
    return this.adminLoginForm.controls;
  }

  get ofc() {
    return this.operatorLoginForm.controls;
  }
  submit() {
    this.isSubmitted = true;
    if (this.adminLoginForm.invalid && this.operatorLoginForm.invalid) return;

    if (this.adminLogin == true) {
      this.userService.login({
        name: this.afc.name.value,
        password: this.afc.password.value,
        operatorCode: 0,
      }).subscribe(() => {
        this.currrentUser = this.userService.getCurrentUser();
        this.navigateAfterLogin();
      });
    } else {
      this.userService.login({
        name: "",
        password: "",
        operatorCode: this.ofc.operatorCode.value
      }).subscribe(() => {
        this.currrentUser = this.userService.getCurrentUser();
        this.navigateAfterLogin();
      });


    }
  }

  private navigateAfterLogin(): void {
    if (
      this.currrentUser.role !== 'superadmin' &&
      !this.tankService.isWebAccessEnabled(this.tankService.currentTank)
    ) {
      this.router.navigateByUrl('/web-access-disabled');
      return;
    }

    if (this.currrentUser.role === 'operador') {
      this.router.navigateByUrl('/new-discharge');
    } else if (this.currrentUser.role === 'admin') {
      this.router.navigateByUrl('/discharges');
    } else {
      this.router.navigateByUrl('/home');
    }
  }

  isAdminLogin() {
    this.adminLogin = !this.adminLogin;
  }

}
